import React from 'react';
import { useTranslation } from 'react-i18next';

interface IHistoryEntry {
    month?: string;
    text: string;
}

interface IHistoryGroup {
    label?: string;
    entries: IHistoryEntry[];
}

interface IHistoryColumn {
    year: string;
    theme?: string;
    groups: IHistoryGroup[];
}

const HistorySection: React.FC = () => {
    const { t } = useTranslation();

    const columns: IHistoryColumn[] = [
        {
            year: '2026',
            groups: [
                {
                   
                    entries: [
                        {  text: t('history.2026.c1') },
                        {  text: t('history.2026.c2') },
                        { text: t('history.2026.c3') },
                    ],
                },
                {
                    entries: [
                        {  text: t('history.2026.p1') },
                        { text: t('history.2026.p2') },
                        { text: t('history.2026.p3') },
                        {  text: t('history.2026.p4') },
                        { text: t('history.2026.p5') },
                    ],
                },
            ],
        },
        {
            year: '2025',
            groups: [
                {
                    entries: [
                        { text: t('history.2025.item1') },
                        { text: t('history.2025.item2') },
                        { text: t('history.2025.item3') },
                        { text: t('history.2025.item4') },
                        { text: t('history.2025.item5') },
                        { text: t('history.2025.item6') },
                    ],
                },
            ],
        },
        {
            year: '2024',
            groups: [
                {
                    entries: [
                        { text: t('history.2024.item1') },
                        { text: t('history.2024.item2') },
                        { text: t('history.2024.item3') },
                        { text: t('history.2024.item4') },
                        { text: t('history.2024.item5') },
                        { text: t('history.2024.item6') },
                    ],
                },
            ],
        },
    ];

    return (
        <section id="history" className="py-10 md:py-12 bg-gray-50">
            <div className="container mx-auto px-6">

                {/* 상단 중앙 타이틀 */}
                <div className="text-center mb-8 md:mb-10">
                    <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3 md:mb-4 border-b-4 border-black pb-2 md:pb-3 inline-block leading-tight">
                        SINCE 2024<br />
                        <span className="text-blue-800">NEUBREZE</span>
                    </h2>
                    <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                        {t('history.since')}<br />
                        {t('history.desc1')} {t('history.desc2')}
                    </p>
                </div>

                {/* 연도별 배치 — 최신 연도가 왼쪽 */}
                <div className="grid grid-cols-1 lg:grid-cols-3 lg:divide-x divide-gray-300 divide-y lg:divide-y-0">
                    {columns.map((column) => (
                        <div key={column.year} className="py-6 lg:py-0 lg:px-7 first:lg:pl-0 last:lg:pr-0">

                            <div className="flex items-baseline justify-between gap-3 mb-4 md:mb-5">
                                <span className="text-2xl md:text-3xl font-black text-blue-600">
                                    {column.year}
                                </span>
                                {column.theme && (
                                    <span className="text-[10px] md:text-[11px] font-bold tracking-wider text-blue-500 text-right leading-tight">
                                        {column.theme}
                                    </span>
                                )}
                            </div>

                            {column.groups.map((group, gi) => (
                                <div key={gi} className={gi > 0 ? 'mt-5 md:mt-6' : ''}>
                                    {group.label && (
                                        <p className="text-[13px] md:text-sm font-bold text-gray-900 mb-3 pb-1.5 border-b border-gray-200">
                                            {group.label}
                                        </p>
                                    )}
                                    <ul className="space-y-2.5 md:space-y-3 text-gray-600 text-[14px] md:text-[15px] font-medium">
                                        {group.entries.map((entry, i) => (
                                            <li key={i} className="flex items-start">
                                                {entry.month ? (
                                                    <span className="text-blue-600 font-bold text-[13px] md:text-sm mt-0.5 mr-3 w-6 flex-shrink-0 tabular-nums">
                                                        {entry.month}
                                                    </span>
                                                ) : (
                                                    <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0" />
                                                )}
                                                <span className="leading-relaxed">{entry.text}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default HistorySection;
